import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import useReveal from "./hooks/useReveal";
import Header from "./components/landing/Header";
import Hero from "./components/landing/Hero";
import Problem from "./components/landing/Problem";
import EmotionalConnect from "./components/landing/EmotionalConnect";
import WhyThis from "./components/landing/WhyThis";
import Solution from "./components/landing/Solution";
import Proof from "./components/landing/Proof";
import Benchmark from "./components/landing/Benchmark";
import WhyIBuiltThis from "./components/landing/WhyIBuiltThis";
import StartHere from "./components/landing/StartHere";
import MarketingAddons from "./components/landing/MarketingAddons";
import AdvisorPackages from "./components/landing/AdvisorPackages";
import LeadMagnet from "./components/landing/LeadMagnet";
import WhoFor from "./components/landing/WhoFor";
import FinalCTA from "./components/landing/FinalCTA";
import Footer from "./components/landing/Footer";

const Landing = () => {
  const containerRef = useReveal();

  return (
    <div
      ref={containerRef}
      data-testid="landing-page"
      className="min-h-screen text-white font-sans-body antialiased selection:bg-amber-500/40"
    >
      <Header />
      <main>
        <Hero />
        <Problem />
        <EmotionalConnect />
        <WhyThis />
        <Solution />
        <Proof />
        <Benchmark />
        <WhyIBuiltThis />
        <StartHere />
        <MarketingAddons />
        <AdvisorPackages />
        <LeadMagnet />
        <WhoFor />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
